import { ActionButton } from '@/components/actions-button/actions-button';
import { useActionPanel } from '@/features/action-panel/use-action-panel';
import { companyIdState } from '@/features/companies/overview/company.state';
import { useCompanyActionsInfo } from '@/features/companies/overview/action-panel/use-company-actions-info.query';
import { useCompany } from '@/features/companies/overview/use-company.query';
import { SpotlightOpenCompanyViewLink } from '@/features/spotlight/spotlight-open-company-view-link';

import { TopbarWrapper } from '../../topbar';
import { useAtomValue } from 'jotai';

export const SpotlightCompanyHeader = () => {
  const companyId = useAtomValue(companyIdState);
  const { data: company } = useCompany(companyId);
  const { data: companyActions } = useCompanyActionsInfo();
  const { toggleActionPanel } = useActionPanel();

  const onToggleActionPanelClick = () => {
    if (!company) return;

    toggleActionPanel({
      context: 'company',
      title: company.name.value ?? '',
    });
  };

  return (
    <TopbarWrapper
      alignItems="center"
      bgColor="white"
      gap="16px"
      justify="flex-end"
      name="spotlight-company-header"
    >
      {company && (
        <ActionButton
          totalValue={companyActions?.files ?? 0}
          onClick={onToggleActionPanelClick}
        />
      )}
      <SpotlightOpenCompanyViewLink />
    </TopbarWrapper>
  );
};
